define((require) => {
    "use strict";

    const _                   = require("underscore");
    const AbstractWidgetModel = require("shared/ui/experience/widgets/AbstractWidgetModel");

    /**
     * Model for a SalesforceCommerce widget.
     *
     * @class SalesforceCommerceWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("SalesforceCommerceWidget", {

        defaults: _.extend({}, AbstractWidgetModel.prototype.defaults, {
            type: "demandware",
            // TODO MOS-2342: Width and height don't seem to be used because FIXED_SIZE is used
            // instead.
            width: 53.3,
            height: 72.5,
            /**
             * @type {String}
             * OCAPI productID, this field is the only thing that the viewer will be able to see.
             */
            productID: null,
            siteId: null
        }),

        fitToScene() {
            this.set({
                left: 0,
                top: 0,
                rotation: 0,
                width: 100,
                height: 100
            });
        }
    }, {
        FIXED_SIZE: {
            width: 100,
            height: 100
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/salesforceCommerceWidget/model/SalesforceCommerceWidgetModel.js